var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.55 24.0877C22.0375 24.6002 21.525 25.3689 21.1406 26.0096C18.8344 24.2158 16.7844 22.0377 14.9906 19.8596C15.7594 19.4752 16.4 18.9627 16.9125 18.4502C19.475 15.8877 18.5781 12.5564 16.0156 9.99393C13.4531 7.43143 10.25 6.40643 7.55938 9.09705C4.86876 11.7877 4.61251 16.4002 6.66251 19.3471C10.3781 24.9846 16.0156 30.6221 21.6531 34.3377C24.7281 36.3877 29.3406 36.0033 31.9031 33.4408C34.4656 30.8783 33.5688 27.5471 31.0063 24.9846C28.4438 22.4221 25.1125 21.3971 22.55 24.0877Z",
    stroke: "#89BE44",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7469 17.8094C35.7469 10.7625 30.1094 5.125 23.0625 5.125",
    stroke: "#89BE44",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 17.5531C29.4688 14.2219 26.65 11.5312 23.1907 11.5312",
    stroke: "#89BE44",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.4ce8caea2f8b8eda343177e527767119.svg";
export { ForwardRef as ReactComponent };